/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the ApiConfiguration configuration object with a given root URL.
 */
export function provideApiConfiguration(rootUrl: string) {
  var config = new ApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'http://localhost:3000';
}

